import { render, staticRenderFns } from "./advance.vue?vue&type=template&id=80ff4ffe&scoped=true&"
import script from "./advance.vue?vue&type=script&lang=js&"
export * from "./advance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ff4ffe",
  null
  
)

export default component.exports